"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CrossCircleThinIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "37",
  height: "37",
  viewBox: "0 0 37 37",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-72.000000, -447.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(73.000000, 448.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(-1.000000, -1.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M18.5,17.2979185 L24.7467853,11.0511331 C25.078731,10.7191875 25.6169212,10.7191875 25.9488669,11.0511331 C26.2531504,11.3554167 26.2785073,11.8330029 26.0249377,12.1661702 L25.9488669,12.2532147 L19.7020815,18.5 L25.9488669,24.7467853 C26.2808125,25.078731 26.2808125,25.6169212 25.9488669,25.9488669 C25.6445833,26.2531504 25.1669971,26.2785073 24.8338298,26.0249377 L24.7467853,25.9488669 L18.5,19.7020815 L12.2532147,25.9488669 C11.921269,26.2808125 11.3830788,26.2808125 11.0511331,25.9488669 C10.7468496,25.6445833 10.7214927,25.1669971 10.9750623,24.8338298 L11.0511331,24.7467853 L17.2979185,18.5 L11.0511331,12.2532147 C10.7191875,11.921269 10.7191875,11.3830788 11.0511331,11.0511331 C11.3554167,10.7468496 11.8330029,10.7214927 12.1661702,10.9750623 L12.2532147,11.0511331 L18.5,17.2979185 Z M18.5,0.15 C28.6344252,0.15 36.85,8.36557484 36.85,18.5 C36.85,28.6344252 28.6344252,36.85 18.5,36.85 C8.36557484,36.85 0.15,28.6344252 0.15,18.5 C0.15,8.36557484 8.36557484,0.15 18.5,0.15 Z M18.5,1.85 C9.30445892,1.85 1.85,9.30445892 1.85,18.5 C1.85,27.6955411 9.30445892,35.15 18.5,35.15 C27.6955411,35.15 35.15,27.6955411 35.15,18.5 C35.15,9.30445892 27.6955411,1.85 18.5,1.85 Z",
            fill: color,
            fillRule: "nonzero"
          })
        })
      })
    })
  })]
});

CrossCircleThinIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = CrossCircleThinIcon;
exports.default = _default;